// extracted by mini-css-extract-plugin
module.exports = {"key":"__c1FS","disabled":"j_z9_t","icon":"IpzJ_A","up":"qzl2Df","right":"P_jegI","left":"_40v1f_","down":"i9YrQk"};